import { render, staticRenderFns } from "./top-menu.vue?vue&type=template&id=2d8dffac&scoped=true&"
import script from "./top-menu.vue?vue&type=script&lang=js&"
export * from "./top-menu.vue?vue&type=script&lang=js&"
import style0 from "./top-menu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./top-menu.vue?vue&type=style&index=1&id=2d8dffac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8dffac",
  null
  
)

export default component.exports